<template>
    <DCard
        :title="__('orders.show.marketing')"
        :main-title-has-slot="true"
        padding
    >
        <template #titleHasSlot>
            <DSwitch
                color="success"
                variant="3d"
                :disabled="isInLoadingState"
                :checked="showSection"
                @update:checked="showCardSection"
            />
        </template>
        <DRow v-if="showSection">
            <DCol col="6">
                <DFormRow :label="__('orders.show.utm_source')">
                    {{ order.utmSource }}
                </DFormRow>
                <DFormRow :label="__('orders.show.utm_medium')">
                    {{ order.utmMedium }}
                </DFormRow>
                <DFormRow :label="__('orders.show.utm_campaign')">
                    {{ order.utmCampaign }}
                </DFormRow>
                <DFormRow :label="__('orders.show.utm_term')">
                    {{ order.utmTerm }}
                </DFormRow>
                <DFormRow :label="__('orders.show.utm_content')">
                    {{ order.utmContent }}
                </DFormRow>
                <DFormRow :label="__('orders.show.utm_id')">
                    {{ order.utmId }}
                </DFormRow>
                <DFormRow :label="__('orders.show.awc')">
                    {{ order.awc }}
                </DFormRow>
                <DFormRow :label="__('orders.show.wmid')">
                    {{ order.wmid }}
                </DFormRow>
                <DFormRow :label="__('orders.show.pid')">
                    {{ order.pid }}
                </DFormRow>
                <DFormRow :label="__('orders.show.referrer')">
                    {{ order.referrer }}
                </DFormRow>
                <DFormRow :label="__('orders.show.lp')">
                    {{ order.lp }}
                </DFormRow>
                <DFormRow :label="__('orders.show.referral_id')">
                    {{ order.referralId }}
                    <a
                        v-if="order.idInternal !== null && order.referralId === null && userPermissions.includes('order.affiliate')"
                        href="#"
                        @click.prevent="openAffiliateModal"
                    >
                        {{ __('orders.show.assign_affiliate') }}
                    </a>
                    <DButton
                        v-if="order.referralId !== null && userPermissions.includes('order.affiliate')"
                        :id="`btn-delete-referral-id`"
                        icon="trash-can-outline"
                        color="danger"
                        mini
                        @click="handeDeleteReferralIdClick()"
                    />
                </DFormRow>
            </DCol>
        </DRow>
        <DModal
            :title="__('orders.show.assign_affiliate')"
            is-confirm
            is-awaiting-validation
            :show="showAffiliateModal"
            @confirm="assignAffiliateConfirm"
            @close="closeModal"
        >
            <div style="padding: 15px;">
                <p>
                    {{ __('orders.show.affiliate_modal.message') }}
                </p>
                <DFormRow
                    :label="__('orders.show.affiliate_modal.affiliate_id')"
                    :is-required="true"
                    :error="errors.affiliate_id"
                >
                    <DInput
                        id="affiliate_id"
                        v-model="form.affiliate_id"
                    />
                </DFormRow>
                <p>
                    {{ __('orders.show.affiliate_modal.switch') }}
                </p>
                <DFormRow
                    :label="__('orders.show.affiliate_modal.emid')"
                    :is-required="true"
                    :error="errors.emid"
                >
                    <DInput
                        id="emid"
                        v-model="form.emid"
                    />
                </DFormRow>
            </div>
        </DModal>
        <DModal
            :title="__('orders.show.delete_referral_id_title')"
            :message="__('orders.show.delete_referral_id_message')"
            is-confirm
            is-error
            is-awaiting-validation
            :show="showDeleteReferralIdModal"
            @confirm="deleteReferralIdConfirm"
            @close="showDeleteReferralIdModal = false"
        />
    </DCard>
</template>

<script setup>

import { computed, ref } from 'vue'
import { usePage, useForm } from '@inertiajs/vue3'
import { route } from '~@/Composables/route'

const props = defineProps({
    order: {
        type: Object,
        default () {
            return {}
        }
    },
    errors: {
        type: Object,
        default () {
            return {}
        }
    },
    section: {
        type: String,
        default () {
            return ''
        }
    },
    showSection: {
        type: Boolean,
        default () {
            return true
        }
    },
    userListView: {
        type: Array,
        default: () => {
            return []
        }
    }
})

const userPermissions = computed(() => usePage().props.auth.permissions)
const showAffiliateModal = ref(false)
const showDeleteReferralIdModal = ref(false)
const form = useForm({
    affiliate_id: '',
    emid: ''
})

function openAffiliateModal () {
    showAffiliateModal.value = true
}

function closeModal () {
    showAffiliateModal.value = false
}

function assignAffiliateConfirm () {
    form.post(route('orders.assign_affiliate', { order: props.order.idInternal }), {
        onSuccess: () => {
            showAffiliateModal.value = false
        },
        onError: () => {
            showAffiliateModal.value = true
        }
    })
}

const emit = defineEmits(['update-list'])

const columns = ref(props.userListView)

const switchButtonForm = useForm({
    columns: props.userListView
})

function showCardSection (value) {
    for (const column of columns.value) {
        if (column.column === props.section) {
            column.show_column = value
        }
    }

    switchButtonForm.columns = flattenColumns(columns.value)

    switchButtonForm.post(route('settings.list-view-settings.store'))

    emit('update-list', columns.value)
}

function flattenColumns (columns) {
    if (columns.length === 0) {
        return {}
    }

    const result = {}

    for (const [key, column] of Object.entries(columns)) {
        result[key] = JSON.parse(JSON.stringify(column))
    }

    return result
}

function handeDeleteReferralIdClick () {
    showDeleteReferralIdModal.value = true
}

function deleteReferralIdConfirm () {
    form.post(route('orders.delete_referral_id', { order: props.order.idInternal }), {
        onSuccess: () => {
            showDeleteReferralIdModal.value = false
        },
        onError: () => {
            showDeleteReferralIdModal.value = true
        }
    })
}
</script>

<style scoped>

</style>
